import { v4 as uuid } from 'uuid';
import { certification as certificationEndpoints } from '../../api/endpoints';

export const CERTIFICATION_GET = 'CERTIFICATION_GET';
export const CERTIFICATION_GET_SUCCESS = 'CERTIFICATION_GET_SUCCESS';
export const CERTIFICATION_FORM_GET = 'CERTIFICATION_FORM_GET';
export const CERTIFICATION_FORM_GET_SUCCESS = 'CERTIFICATION_FORM_GET_SUCCESS';
export const CERTIFICATION_ANSWER = 'CERTIFICATION_ANSWER';
export const CERTIFICATION_ANSWER_SUCCESS = 'CERTIFICATION_ANSWER_SUCCESS';
// v5 only
export const CERTIFICATION_GET_QUESTION = 'CERTIFICATION_GET_QUESTION';
export const CERTIFICATION_GET_QUESTION_SUCCESS = 'CERTIFICATION_GET_QUESTION_SUCCESS';
// v5 only
export const CERTIFICATION_UPDATE_QUESTION = 'CERTIFICATION_UPDATE_QUESTION';

/*
 * To better understand certifications workflow, more details are available in the headers of
 * CertificationPage.jsx (used to answer certification questions) and ContributeAnswerPage.jsx
 * (used to read certification answers)
 */

// Candidate's test: loads the next question of their own certification test
export const getCertification = (certificationId, meta = {}) => ({
  type: CERTIFICATION_GET,
  fetch: { ...certificationEndpoints.get(certificationId), auth: true },
  meta: { requestId: uuid(), ...meta },
});

export const getFormCertification = (formId) => ({
  type: CERTIFICATION_FORM_GET,
  fetch: { ...certificationEndpoints.getForm(formId), auth: true },
  meta: { requestId: uuid() },
});

// Candidate's test: submits the candidate's own answer to the current question
export const createCertificationAnswer = (
  certificationId,
  certificationUserId,
  certificationQuestionId,
  certificationUserQuestionId,
  json,
  meta = {},
) => ({
  type: CERTIFICATION_ANSWER,
  fetch: {
    ...certificationEndpoints.createAnswer(
      certificationId,
      certificationUserId,
      certificationQuestionId,
      certificationUserQuestionId,
      json,
    ),
    auth: true,
  },
  meta: { requestId: uuid(), ...meta },
});

// v5 only
// Manager publish flow: loads ONE question of the certification referential, so that a manager
// can define its reference answer. No-op in v3, which has no such endpoint.
export const getCertificationQuestion = (certificationId, questionId, meta = {}) => {
  if (!certificationEndpoints.getQuestion) {
    return { type: CERTIFICATION_GET_QUESTION, meta: { requestId: uuid(), ...meta } };
  }
  return {
    type: CERTIFICATION_GET_QUESTION,
    fetch: { ...certificationEndpoints.getQuestion(certificationId, questionId), auth: true },
    meta: { requestId: uuid(), ...meta },
  };
};

// v5 only
// Manager publish flow: saves the reference answer of a referential question, which candidate
// answers will be corrected against. No-op in v3, which has no such endpoint.
export const updateCertificationQuestionAnswer = (
  certificationId,
  questionId,
  jsonAnswer,
  meta = {},
) => {
  if (!certificationEndpoints.updateQuestionAnswer) {
    return { type: CERTIFICATION_UPDATE_QUESTION, meta: { requestId: uuid(), ...meta } };
  }
  return {
    type: CERTIFICATION_UPDATE_QUESTION,
    fetch: {
      ...certificationEndpoints.updateQuestionAnswer(certificationId, questionId, jsonAnswer),
      auth: true,
    },
    meta: { requestId: uuid(), ...meta },
  };
};
